import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Receipt, Loader2 } from "lucide-react";
import { API, authHeaders } from "@/lib/site";

const STATUS_STYLE = {
  paid: "text-emerald-600 dark:text-emerald-400",
  pending: "text-amber-600 dark:text-amber-400",
  failed: "text-red-500",
  expired: "text-slate-400",
};

export default function BillingTab() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    axios.get(`${API}/orders`, { headers: authHeaders() })
      .then(({ data }) => setOrders(data.orders))
      .catch(() => { toast.error("Could not load orders."); setOrders([]); });
  }, []);

  if (orders === null) return <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  if (orders.length === 0)
    return (
      <div data-testid="billing-empty" className="rounded-3xl border border-dashed border-slate-300 dark:border-slate-700 p-16 text-center">
        <Receipt className="w-10 h-10 mx-auto text-slate-300 dark:text-slate-600" />
        <p className="mt-4 font-semibold">No payments yet</p>
        <p className="mt-2 text-sm text-slate-500">Your VPS orders will appear here after checkout.</p>
      </div>
    );

  return (
    <div className="space-y-4" data-testid="billing-list">
      {orders.map((o) => (
        <div key={o.session_id} data-testid={`order-row-${o.session_id}`}
             className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 sm:p-6 flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="font-semibold">{o.plan_name}</p>
            <p className="text-xs text-slate-500 mt-1">{new Date(o.created_at).toLocaleString()} · {o.server_id ? "server deployed" : "no server linked"}</p>
          </div>
          <div className="flex items-center gap-6">
            <span className="font-display font-bold text-lg">${o.amount?.toFixed(2)} <span className="text-xs font-normal uppercase text-slate-400">{o.currency}</span></span>
            <span className={`text-xs font-bold uppercase tracking-wider ${STATUS_STYLE[o.payment_status] || "text-slate-400"}`}>
              {o.payment_status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
